import { ShoesState } from 'src/types'

export const toeDesign = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.sideReinforcement.color
  ctx.lineWidth = 1.0
  ctx.beginPath()
  ctx.moveTo(30, 442) //つま先＿左下
  ctx.quadraticCurveTo(20, 415, 60, 389)
  ctx.quadraticCurveTo(106, 370, 133, 389)
  ctx.quadraticCurveTo(164, 425, 186, 476)
  ctx.quadraticCurveTo(197, 491, 203, 501)
  ctx.quadraticCurveTo(246, 509, 281, 508) // 右下
  ctx.quadraticCurveTo(268, 497, 248, 465)
  ctx.quadraticCurveTo(194, 390, 194, 390)
  ctx.quadraticCurveTo(249, 430, 309, 494)
  ctx.quadraticCurveTo(302, 435, 306, 412) // 右上
  ctx.quadraticCurveTo(215, 358, 215, 358)
  ctx.quadraticCurveTo(142, 351, 142, 351)
  ctx.quadraticCurveTo(89, 348, 64, 368)
  ctx.quadraticCurveTo(13, 405, 30, 442)
  // ctx.quadraticCurveTo()

  ctx.fill()

  // 断面の芯通しの白
  ctx.strokeStyle = 'white'
  ctx.lineWidth = 2.5
  ctx.beginPath()
  ctx.moveTo(28, 442) //つま先＿左下
  ctx.quadraticCurveTo(18, 413, 58, 387)
  ctx.quadraticCurveTo(104, 368, 131, 387)
  ctx.quadraticCurveTo(164, 425, 186, 475)
  ctx.quadraticCurveTo(190, 487, 202, 499)

  ctx.moveTo(215, 358)
  ctx.quadraticCurveTo(263, 383, 305, 412)
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()

  ctx.moveTo(191, 386)
  ctx.quadraticCurveTo(265, 495, 265, 495)
  ctx.quadraticCurveTo(278, 507, 278, 509)

  ctx.moveTo(191, 386)
  ctx.quadraticCurveTo(248, 432, 308, 493)

  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.lineWidth = 1.5
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(34, 405) // 左上
  ctx.quadraticCurveTo(49, 380, 87, 375)
  ctx.quadraticCurveTo(123, 370, 146, 395)
  ctx.quadraticCurveTo(163, 412, 190, 468)
  ctx.quadraticCurveTo(197, 485, 212, 501)

  ctx.moveTo(34, 402) // 左上
  ctx.quadraticCurveTo(49, 377, 87, 372)
  ctx.quadraticCurveTo(123, 364, 146, 390)
  ctx.quadraticCurveTo(169, 406, 193, 465)
  ctx.quadraticCurveTo(217, 502, 217, 502)

  ctx.moveTo(182, 381)
  ctx.quadraticCurveTo(215, 437, 270, 508)
  ctx.moveTo(182, 381)
  ctx.quadraticCurveTo(193, 376, 228, 405)
  ctx.quadraticCurveTo(307, 477, 307, 477)

  ctx.moveTo(204, 359)
  ctx.quadraticCurveTo(248, 381, 303, 424)
  ctx.moveTo(204, 357)
  ctx.quadraticCurveTo(248, 375, 303, 419)
  // ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#383838'

  //   canvasResetter(ctx) // リセット
}

// ctx.beginPath()
// ctx.moveTo(0, 0)
// ctx.quadraticCurveTo(0, 0, 0, 0)
// ctx.closePath()
